import { VueConstructor, PluginObject } from 'vue';
import Notifications from "./list.vue";
import { Notification } from '@/store/modules/notifications';
import store from '@/store';

export interface NotificationsOptions {};

let NotificationsPlugin: PluginObject<NotificationsOptions> = {
  install(Vue: VueConstructor) {
    Vue.mixin({
      methods: {

        notify(notification: Notification): void  {

          if (!notification.horizontalAlign) notification.horizontalAlign = 'center';
          if (!notification.verticalAlign) notification.verticalAlign = 'top';
          if (!notification.type) notification.type = 'info';
          if (!notification.icon) notification.icon = 'mdi-bell';

          store.dispatch('notifications/notify', notification);

        },

        notifyByType(type: string, message: string): void {

          let icon = 'mdi-bell';
          let timeout = 7000;
          switch (type) {
            case 'info':
              icon = 'mdi-information';
              break;
            case 'dange':
              icon = 'mdi-alert-octagon';
              timeout = 10000;
              break;
            case 'primary':
              icon = 'mdi-alert-box';
              break;
            case 'warning':
              icon = 'mdi-alert';
              timeout = 10000;
              break;
            case 'success':
              icon = 'mdi-bell';
          }

          store.dispatch('notifications/notify', {
            horizontalAlign: 'center',
            verticalAlign: 'top',
            icon,
            message,
            timeout,
            type,
          });

        },

      },
    });
    Object.defineProperty(Vue.prototype, "$notify", {
      get() { return this.$root.notify; }
    });
    Object.defineProperty(Vue.prototype, "$notifyInfo", {
      get() { return this.$root.notifyByType.bind(null, 'info'); }
    });
    Object.defineProperty(Vue.prototype, "$notifyDange", {
      get() { return this.$root.notifyByType.bind(null, 'dange'); }
    });
    Object.defineProperty(Vue.prototype, "$notifyPrimary", {
      get() { return this.$root.notifyByType.bind(null, 'primary'); }
    });
    Object.defineProperty(Vue.prototype, "$notifyWarning", {
      get() { return this.$root.notifyByType.bind(null, 'warning'); }
    });
    Object.defineProperty(Vue.prototype, "$notifySuccess", {
      get() { return this.$root.notifyByType.bind(null, 'success'); }
    });
    Object.defineProperty(Vue.prototype, "$notifyRose", {
      get() { return this.$root.notifyByType.bind(null, 'rose'); }
    });
    Vue.component('notifications', Notifications);
  }
};

export default NotificationsPlugin;
